export default __webpack_public_path__ + "static/one-drive-hero-img-c749dc4b6529fee35e2c62ef9a293544.png";